import { AbstractCommand } from "./AbstractCommand"
import { CommandResponse } from "../types"
import { getSequenceId } from "../utils/sequenceIdManager"

export class LoadFilamentCommand extends AbstractCommand {
	public readonly category = "print"
	public readonly command = "ams_change_filament" as const

	constructor({
		trayId,
		oldTemp = 210,
		newTemp = 210,
	}: {
		trayId: number
		oldTemp?: number
		newTemp?: number
	}) {
		super({
			target: trayId,
			curr_temp: oldTemp,
			tar_temp: newTemp,
		})
	}

	ownsResponse(response: CommandResponse, sequence_id?: string): boolean {
		if (!("print" in response)) {
			return false
		}

		const printResponse = response as { print: { sequence_id?: string | undefined } }
		const responseId = printResponse.print?.sequence_id
		const extraId = this.extra?.sequence_id

		if (!responseId) {
			return false
		}

		if (sequence_id && responseId === sequence_id) {
			return true
		}

		if (extraId && responseId === extraId) {
			return true
		}

		return false
	}
}
